import { Link } from "react-router-dom";
import { column, StandartCollectionController } from "../../types";
import formatText from "../../utils/textFormatter";

const columns: column[] = [
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
    dataType: "string",
    render: (_id, record) => (
      <Link to={`/hotels/${record._id}`} className="font-semibold">
        {record.code}
      </Link>
    ),
  },
  {
    title: "Museum Name",
    dataIndex: "name",
    key: "name",
    dataType: "string",
    render: (_id, record) => (
      <Link to={`/museums/${record._id}`} className="font-semibold">
        {record.name}
      </Link>
    ),
  },
  {
    title: "Province",
    dataIndex: "province._id",
    key: "province._id",
    dataType: "string",
    render: (_id, record) => <div>{record?.province?.name}</div>,
  },
];

const form: any = {
  type: "form",
  requestType: "create",
  items: [
    {
      type: "xStack",
      breakpoint: "md",
      gap: 4,
      align: "start",
      justify: "between",
      items: [
        {
          type: "yStack",
          gap: 4,
          height: "100%",
          span: 3,
          items: [
            {
              type: "grid",
              cols: 12,
              gap: 2,
              items: [
                {
                  type: "field",
                  name: "code",
                  label: "Code",
                  span: 2,
                  item: {
                    type: "text",
                    placeholder: "code",
                    format: {
                      onChange: "trim",
                    },
                  },
                  validations: {
                    required: {
                      message: "Code is required",
                    },
                  },
                },
                {
                  type: "field",
                  name: "name",
                  label: "Museum Name",
                  span: 10,
                  item: {
                    type: "text",
                    placeholder: "museum name",
                    format: {
                      onChange: "removeExtraSpaces",
                      onSubmit: "trim",
                    },
                  },
                  validations: {
                    required: {
                      message: "Müze ismi alanı zorunludur",
                    },
                  },
                },
                {
                  type: "field",
                  name: "address",
                  label: "Museum Address",
                  span: 12,
                  item: {
                    type: "textarea",
                    placeholder: "museum address",
                    rows: 2,
                    format: {
                      onChange: "removeExtraSpaces",
                      onSubmit: "trim",
                    },
                  },
                  validations: {
                    required: {
                      message: "Müze adresi alanı zorunludur",
                    },
                  },
                },
                {
                  type: "field",
                  name: "province",
                  label: "Province",
                  validations: {
                    required: true,
                  },
                  span: 12,
                  item: {
                    type: "select",
                    placeholder: "Select province",
                    search: true,
                    mode: "default",
                  },
                  remote: {
                    url: `${process.env.REACT_APP_API_URL}/api/provinces?search={{value}}`,
                    fetchOnMount: true,
                    value: "_id",
                  },
                },
                {
                  type: "field",
                  fieldType: "array",
                  name: "contacts",
                  label: "Contacts",
                  span: 12,
                  item: {
                    type: "field",
                    name: "contactinfo",
                    //label: "Hesap Numarası",
                    fieldType: "object",
                    compact: true,
                    span: 12,
                    items: [
                      {
                        type: "field",
                        name: "name",
                        label: "Name",
                        span: 4,
                        item: {
                          type: "text",
                          placeholder: "name",
                          format: {
                            onChange: "removeExtraSpaces",
                            onSubmit: "trim",
                          },
                        },
                      },
                      {
                        type: "field",
                        name: "phone",
                        label: "Phone",
                        span: 4,
                        item: {
                          type: "text",
                          placeholder: "phone",
                          format: {
                            onChange: "phoneNumberWithCountryCode",
                            onSubmit: "dbPhoneNumber",
                          },
                        },
                        validations: {
                          pattern: {
                            value: /^\+\d{1,3} \d{3,14}$/,
                            message: "Telefon numarası geçersiz",
                          },
                        },
                      },
                      {
                        type: "field",
                        name: "email",
                        label: "E-mail",
                        span: 4,
                        item: {
                          type: "text",
                          placeholder: "email",
                          format: {
                            onChange: "trim",
                          },
                        },
                        validations: {
                          pattern: {
                            value: /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/,
                            message: "E-posta adresi geçersiz",
                          },
                        },
                      },
                    ],
                  },
                },

                {
                  type: "field",
                  fieldType: "array",
                  name: "pricing",
                  label: "Pricing",
                  span: 12,
                  item: {
                    type: "field",
                    name: "price",
                    fieldType: "object",
                    compact: true,
                    span: 12,
                    items: [
                      {
                        type: "field",
                        name: "code",
                        label: "Code",
                        span: 2,
                        item: {
                          type: "text",
                          placeholder: "code",
                          format: {
                            onChange: "trim",
                          },
                        },
                        validations: {
                          required: {
                            message: "Code is required",
                          },
                        },
                      },
                      {
                        type: "field",
                        name: "name",
                        label: "Description",
                        span: 5,
                        item: {
                          type: "text",
                          placeholder: "name",
                        },
                      },
                      {
                        type: "field",
                        name: "price",
                        label: "Price",
                        span: 3,
                        item: {
                          type: "Number",
                          placeholder: "20",
                          format: {
                            step: 0.1,
                          },
                          limitations: {
                            min: 0,
                          },
                        },
                        validations: {
                          required: true,
                        },
                      },
                      {
                        type: "field",
                        name: "currency",
                        label: "Currency",
                        span: 2,
                        item: {
                          type: "select",
                          placeholder: "USD",
                          mode: "default",
                        },
                        options: [
                          {
                            value: "TRY",
                            label: "TRY",
                          },
                          {
                            value: "USD",
                            label: "USD",
                          },
                          {
                            value: "EUR",
                            label: "EUR",
                          },
                        ],
                      },
                    ],
                  },
                },

                {
                  type: "button",
                  inputType: "submit",
                  value: "Kaydet",
                  span: 12,
                },
              ],
            },
          ],
        },
        {
          type: "yStack",
          gap: 4,
          span: 3,
          items: [
            {
              type: "grid",
              cols: 12,
              gap: 2,
              items: [
                {
                  type: "field",
                  fieldType: "array",
                  name: "workingDays",
                  label: "Working Days",
                  span: 12,
                  item: {
                    type: "field",
                    name: "wd",
                    fieldType: "object",
                    compact: true,
                    span: 12,
                    items: [
                      {
                        type: "field",
                        name: "day",
                        label: "Name",
                        span: 6,
                        item: {
                          type: "text",
                          placeholder: "day",
                        },
                      },
                      {
                        type: "field",
                        name: "openingTime",
                        label: "Opening Time",
                        span: 3,
                        item: {
                          type: "text",
                          placeholder: "08:00",
                        },
                      },
                      {
                        type: "field",
                        name: "closingTime",
                        label: "Closing Time",
                        span: 3,
                        item: {
                          type: "text",
                          placeholder: "16:00",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export class MuseumController extends StandartCollectionController {
  constructor() {
    super("Museum", "museums", {
      columns,
      form,
    });
  }
}
